<template>
  <div class="container-fluid" v-if="userData.permissions['report_cards'] == 1">
    <div class="my-2" v-if="exammarks.length <= 0">
      <div class="mt-5 text-center">
        <b-spinner type="grow" variant="primary" label="Loading"></b-spinner>
      </div>
    </div>
    <div v-else>
      <div v-for="item in exammarks" :key="item.id" class="reportCard">
        <div
          style="font-family:'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif"
        >
          <div class="d-flex justify-content-between">
            <div>
              <span v-if="userData.logo != 0"
                ><img :src="getLogo(userData.logo)" height="80"/><br
              /></span>
              <span v-else
                ><img src="@/assets/images/logo.png" height="80"/></span
              ><br />
            </div>
            <div>
              <img :src="getFiles(item.students.student_photo)" height="80" />
            </div>
          </div>
          <div>
            <div class="text-center">
              <h5 style="color:black" class="text-uppercase mb-0">
                {{ userData.school }}
              </h5>
              <span style="color:black;font-size:12px"
                >Location : {{ userData.location }}</span
              ><br />
              <span style="color:black;font-size:12px"
                >Telephone : {{ userData.contact }}</span
              ><br /><br />
              <span
                style="color: black;font-size:18px"
                class="text-uppercase text-decoration-underline"
                ><b> {{ $route.query.termname }} Report</b></span
              ><br />
              <!-- {{ $route.query.examname }} -->
            </div>
          </div>
          <div class="d-flex justify-content-evenly">
            <div class="text-uppercase " style="font-size: large;">
              NAME : {{ item.students.first_name }}
              {{ item.students.last_name }} <br />
              CLASS : {{ $route.query.classname }}
            </div>
            <div class="text-uppercase " style="font-size: large;">
              TERM : {{ $route.query.termname }} <br />
              YEAR : {{ $route.query.year }}
            </div>
          </div>

          <!-- Subject & their details-->
          <div class="row mt-3">
            <div class="col-md-12 mx-auto">
              <table class="table table-sm">
                <thead>
                  <tr
                    class="text-uppercase text-align-center"
                    style="border-bottom: 2px solid black;"
                  >
                    <th>Learning Area</th>
                    <th>Expected Level</th>
                    <th>Child's Level</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="y in item.exams" :key="y.id">
                    <td>{{ y.subjects.name }}</td>
                    <td>{{ y.details[0].detail }}</td>
                    <!-- <td>{{y.mark[0].mark}}</td> -->
                    <td style="font-size: large;">
                      <span v-if="y.mark[0].mark >= 96">A</span>
                      <span v-if="y.mark[0].mark >= 80 && y.mark[0].mark <= 95"
                        >B</span
                      >
                      <span v-if="y.mark[0].mark >= 50 && y.mark[0].mark <= 79"
                        >C</span
                      >
                      <span v-if="y.mark[0].mark >= 30 && y.mark[0].mark <= 49"
                        >D</span
                      >
                      <span v-else-if="y.mark[0].mark <= 48">E</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="d-flex justify-content-between mt-4">
            <div class="teacher-comment">
              <h5>Class Teacher's Comment:</h5>
              <p class="signature-line">
                ......................................................................................................................................
              </p>
              <p class="signature-line">
                Signature:
                ............................................................
              </p>
            </div>
            <div class="headteacher-comment">
              <h5>Head Teacher's Comment:</h5>
              <p class="signature-line">
                .......................................................................................................................................
              </p>
              <p class="signature-line">
                Signature:
                ............................................................
              </p>
            </div>
          </div>

          <br /><span
            >Next Term Begins on :
            <strong class="text-uppercase">
              {{ date(userData.next_term) }}</strong
            ></span
          >

          <div class="row mt-3">
            <div class="col-md-10 mx-auto">
              <div class="mt-4">
                <h5><strong>KEY :</strong></h5>
                <table class="table table-sm" border="3">
                  <tr>
                    <td>A</td>
                    <td>B</td>
                    <td>C</td>
                    <td>D</td>
                    <td>E</td>
                  </tr>
                  <tr>
                    <th>Excellent<br /><small>(95% - 100%)</small></th>
                    <th>Very Good<br /><small>(80% - 94%)</small></th>
                    <th>Good<br /><small>(50% - 79%)</small></th>
                    <th>Average<br /><small>(30% - 49%)</small></th>
                    <th>Needs Improvement<br /><small>(0% - 29%)</small></th>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="row justify-content-center">
      <div class="col-md-8 col-xl-6">
        <div>
          <center>
            <span class="text-primary h4"
              >You have no permission to Print the Report Cards.</span
            >
          </center>
          <img
            src="@/assets/images/profile-img.png"
            alt
            class="img-fluid"
          /><br /><br />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import appConfig from "@/app.config";
import axios from "axios";

export default {
  page: {
    title: "Report Cards",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      id: "",
      schoolterm: "",
      schoolclass: "",
      exam: "",
      year: "",
      exammarks: [],
    };
  },
  mounted() {
    this.FilterData();
  },
  methods: {
    Initials(speaker) {
      if (!speaker) return;
      const name = speaker.split(" ");
      return `${name[0].charAt(0)}${name[1] ? name[1].charAt(0) : ""}`;
    },
    getLogo(name) {
      let url = axios.defaults.baseURL;
      let imagelink = url.slice(0, -3) + "logos/" + name;
      return imagelink;
    },
    getFiles(name) {
      let url = axios.defaults.baseURL;
      let imagelink = url.slice(0, -3) + "students/" + name;
      return imagelink;
    },
    date(dateString) {
      const date = new Date(dateString);
      const day = date.getDate();
      const month = date.toLocaleString("default", { month: "long" });
      const year = date.getFullYear();

      const getDaySuffix = (day) => {
        if (day >= 11 && day <= 13) return `${day}th`;
        switch (day % 10) {
          case 1:
            return `${day}st`;
          case 2:
            return `${day}nd`;
          case 3:
            return `${day}rd`;
          default:
            return `${day}th`;
        }
      };
      return `${getDaySuffix(day)} ${month} ${year}`;
    },
    FilterData() {
      let formData = new FormData();
      formData.append("schoolterm", this.$route.query.term);
      formData.append("year", this.$route.query.year);
      formData.append("schoolclass", this.$route.query.class);
      formData.append("exam", this.$route.query.exam);
      let url = "/nurseryreportmarks";
      axios.post(url, formData).then((response) => {
        this.exammarks = response.data.marks;
        setTimeout(() => {
          window.print();
          window.onafterprint = this.$router.go(-1);
        }, 1000);
      });
    },
  },
};
</script>

<style>
@media print {
  .reportCard {
    page-break-before: always;
  }
}
table,
th,
td {
  border: 1px solid black;
  padding: 5px;
  border-collapse: collapse;
}
</style>
